/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentTemplate } from 'app/shared/model/treatment-template.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDoctor } from 'app/shared/model/doctor.model';

export interface ITreatmentDeliveryPlan {
  id?: string;
  startDate?: number | null;
  endDate?: number | null;
  status?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  template?: ITreatmentTemplate | null;
  patient?: IGlucoUser | null;
  physician?: IDoctor | null;
}

export const defaultValue: Readonly<ITreatmentDeliveryPlan> = {
  active: false,
};
